import { useSelector } from "react-redux";
import "./AmBenchmarkHome.scss";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  TablePagination,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import { IoIosRefresh } from "react-icons/io";
import { CiImageOn } from "react-icons/ci";
import { MdAdd, MdArrowBackIos, MdClose } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import { IoDocumentTextSharp } from "react-icons/io5";
import newRequest from "../../../utils/newRequest";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import { getCssValue } from "../../../utils/genericFunctions";
import { useTranslation } from "react-i18next";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports";


const AmBenchmarkHome = () => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [confirmationActiontext, setConfirmationActiontext] = useState("");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [searchTerm, setSearchTerm] = useState("");
  const [allBenchmarks, setAllBenchmarks] = useState([]);
  const [benchmarks, setBenchmarks] = useState([]);
  const [selectedBenchmark, setSelectedBenchmark] = useState(null);
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: ""
  });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentBenchmarkPage, setCurrentBenchmarkPage] = useState(0);
  const [selectedClass, setSelectedClass] = useState(null);
  const [assetClasses, setAssetClasses] = useState([]);
  const [reportGroupArray, setReportKeysArray] = useState(["am-benchmarks"]);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const location = useLocation();
  const showBack = location.state?.showBack || "N";

  const handleBenchmarkPageChange = (event, newPage) => {
    setCurrentBenchmarkPage(newPage);
  };

  const handleBenchmarkRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentBenchmarkPage(0);
  };

  const filteredBenchmarks = benchmarks?.filter(
    (row) =>
      row?.benchmark_code?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      row?.benchmark_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      row?.ticker_symbol?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const paginatedBenchmarks = filteredBenchmarks?.slice(
    currentBenchmarkPage * rowsPerPage,
    currentBenchmarkPage * rowsPerPage + rowsPerPage
  );

  const fetchBenchmarks = async (firstTime) => {
    try {
      if (firstTime) {
        setIsLoading(true);
      } else {
        setIsProcessing(true);
      }
      const res = await newRequest.post("/benchmark/findAll", { result_limit: 100 });
      setAllBenchmarks(res.data);
      setBenchmarks(res.data);
      setIsLoading(false);
      setIsProcessing(false);
    } catch (error) {
      setIsLoading(false);
      setIsProcessing(false);
    }
  };

  const fetchAssetClasses = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Asset Classes" });
      const options = [{ _id: "All", sys_code: "All", sys_name: "All", sys_desc: "View all" }, ...res.data];
      setAssetClasses(options);
      setSelectedClass(options[0]);
    } catch (err) {
      console.log(err);
    }
  };


  const handleSearchBenchmarks = async () => {
    try {
      setIsLoading(true);
      if (searchTerm) {
        const res = await newRequest.post("/benchmark/search", { search_input: searchTerm });
        setBenchmarks(res.data);
      } else {
        fetchBenchmarks();
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBenchmarks(true);
    fetchAssetClasses();
  }, []);

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "openVisit") {

      }

    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  return (
    <div className="benchmarks">
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <motion.div
          className="benchmarks-wrapper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}>
          <div className="benchmarks-center-wrapper">
            <div className="center-navbar">
              <div className="navbar-left">{t('benchmarks').toUpperCase()}</div>
              <div className="navbar-right">
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="left"
                  endIcon={<IoIosRefresh />} onClick={fetchBenchmarks}>
                  {t('refresh')}
                </CustomLoadingButton>
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="none"
                  endIcon={<IoDocumentTextSharp />}
                  onClick={() => setReportsDialogOpen(true)}>
                  {t('reports')}
                </CustomLoadingButton>
                <CustomLoadingButton
                  endIcon={<MdAdd />}
                  iconPosition="end"
                  borderRadiusType="right"
                  currentTheme={currentTheme}
                  onClick={() => {
                    try {
                      navigate(`/benchmark/new`);
                    } catch (error) {
                      console.log(error)
                    }
                  }}
                >
                  {t('newBenchmark')}
                </CustomLoadingButton>
                {/* This part shows if the menu was opened from home screen */}
                {showBack === "Y" && <hr className="separator-v" />}
                {showBack === "Y" &&
                  <span className="back-icon" onClick={() => navigate(-1)}>
                    <MdArrowBackIos size={24} />
                  </span>}
              </div>
            </div>
            <div className="center-content">
              <div className="table-content">
                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                  <Table sx={{ width: "max-content", border: 'none' }}>
                    <TableHead className="tablehead">
                      <TableRow className="tablerow">
                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                          #
                        </TableCell>
                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                          <div className="search-input-wrapper" style={{ display: "flex", width: "100%" }}>
                            <FiSearch className="search-input-icon" />
                            <input
                              className="search-input"
                              type="text"
                              placeholder={`${t('search')} ${t('benchmark')}`}
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') handleSearchBenchmarks();
                              }}
                            />
                            {searchTerm.length > 0 && (
                              <MdClose
                                onClick={async (e) => {
                                  try {
                                    setSearchTerm("");
                                    await fetchBenchmarks();
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                className="search-input-icon"
                              />
                            )}
                            {searchTerm?.length === 0 && (
                              <span className="search-input-icon" />
                            )}
                          </div>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                          <span />
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                          <span>{t('status')}</span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="tablebody">
                      {paginatedBenchmarks?.map((row, index) => (
                        <TableRow
                          key={row._id}
                          className={`${selectedBenchmark?._id === row._id ? "tablerow current" : "tablerow"}`}
                          onClick={() => {
                            try {
                              setSelectedBenchmark(row);
                              navigate(`/benchmark/${row._id}`);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            {currentBenchmarkPage * rowsPerPage + index + 1}
                          </TableCell>

                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                            <div className="benchmark-details">
                              {row?.benchmark_logo_url ? <img src={row?.benchmark_logo_url} alt="" className='benchmark-avatar' />
                                :
                                <CiImageOn style={{ width: "40px", height: "40px" }} />
                              }
                              <div className="benchmark-name">
                                <span className="name">{row?.benchmark_name}</span>
                                <span className="code">{row?.benchmark_code}</span>
                              </div>
                              <div className="benchmark-name">
                                <span className="name">{row?.data_source}</span>
                                <span className="code">{row?.base_currency}</span>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "250px" }}>
                            <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "5px" }}>
                              <span className={`status ${row?.benchmark_status}`} style={{ width: "2px" }} />
                              <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                <span className="sub-title">{`${row?.benchmark_region}`}</span>
                                <span className="sub-title xrsmall soft">{`${t('rebalance')} ${row?.rebalance_frequency}`}</span>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                            <span className={`sub-title xrsmall status ${getCssValue(row?.benchmark_status)}`}>{row?.benchmark_status}</span>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  {benchmarks?.length > benchmarks?.length &&
                    <TablePagination
                      rowsPerPageOptions={[10]}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleBenchmarkRowsPerPage}
                      component="div"
                      count={benchmarks?.length}
                      rows={benchmarks}
                      page={currentBenchmarkPage}
                      onPageChange={handleBenchmarkPageChange}
                    />}
                </TableContainer>
              </div>
            </div>
          </div>
          <div className="benchmarks-right-wrapper">
            <div className="options-list">
              {assetClasses?.map((row) => (
                <span
                  key={row._id}
                  className={`${selectedClass?._id === row._id
                    ? "single-option active"
                    : "single-option"
                    }`}
                  onClick={async () => {
                    try {
                      if (row?.sys_code === "All") {
                        await fetchBenchmarks();
                        setSelectedClass(row);
                      } else {
                        setSelectedClass(row);
                        const filteredBenchmarks = allBenchmarks.filter(
                          (sec) => sec?.asset_class_code === row?.sys_code
                        );
                        setBenchmarks(filteredBenchmarks);
                      }
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  <h1 className="sub-title">{row?.sys_name}</h1>
                  <h1 className="sub-title xrsmall soft">{row?.sys_code}</h1>
                </span>
              ))}
            </div>
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={reportGroupArray}
                documentData={{
                  docNo: "1",
                  docId: "1",
                  docType: "AM Benchmark",
                  format: "xlsx",
                  entity_code: "",
                  date_fm: "",
                  date_to: "",
                  status: "",
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={() => setIsNotifyDialogOpen(false)}>Close</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle="Confirmation"
        dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
      />
    </div>
  )
}

export default AmBenchmarkHome